import { regexPatterns } from '../../constants/regexPatterns';

const validateEmail = value => {
  if (!value.match(regexPatterns.emailAddress)) {
    return { valid: false, message: 'Incorrect email format' };
  }

  return { valid: true, message: '' };
};

export const validateCustomValue = (value, validationType) => {
  switch (validationType) {
    case 'emailAddress':
      return validateEmail(value);
    default:
      break;
  }
};
